module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsYearly@2x.0e2d28c.jpg";